import axios from "axios";

const BASE_URL = "https://syw.bodoland.gov.in/Dashboard/public/api/v1";
// https://syw.bodoland.gov.in/Dashboard/public/api/v1/gallery/allImages

export  const  fetchApi = async (url) => {
    const {data} = await axios.get(`${BASE_URL}/${url}`)
    return data;
 }